import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import SEO from '../../components/SEO';
import HomeIntro from '../../components/Home/HomeIntro';
import HomeSection from '../../components/Home/HomeSection';
import Resources from '../../components/Home/Resources';
import ThreeModel from '../../components/Home/ThreeModel';
import InterviewBlobs from '../../components/Home/InterviewBlobs';
import HomeEmailCapture from '../../components/Home/HomeEmailCapture';
import SubmissionForm from '../../components/SubmissionForm';
import NavExpander from '../../containers/NavExpander';
import MarqueeGroup from '../../containers/MarqueeGroup';

import Config from '../../config';
import styles from './home.css';

const Home = ({ homepage, interviews }) => {
  const homeRoot = useRef(null);

  return (
    <div>
      <SEO title="Upstatement Art Direction" />
      <NavExpander tabIndex="0">
        <div className={styles.wrapper}>
          <div ref={homeRoot} className={styles.content}>
            <HomeSection maxWidth={true}>
              <HomeIntro introduction={homepage.introduction} />
            </HomeSection>
            <HomeSection
              buttonText="View All"
              buttonLink="/interviews"
              maxWidth={true}
              title="Artist Interviews">
              <InterviewBlobs interviews={interviews} />
            </HomeSection>
            <HomeSection title="Testaments of Greatness">
              <MarqueeGroup data={Config.testimonials} />
            </HomeSection>
            <div className={styles.formWrapper}>
              <SubmissionForm />
            </div>
            <HomeSection
              buttonText="View All"
              buttonLink="/resources"
              title="Resourceful Resources"
              maxWidth={true}>
              <Resources data={homepage.resources} />
            </HomeSection>
            <HomeEmailCapture />
            <ThreeModel parent={homeRoot} />
          </div>
        </div>
      </NavExpander>
    </div>
  );
};

Home.propTypes = {
  homepage: PropTypes.object,
  interviews: PropTypes.array,
};

export default withRouter(Home);
